import { FC, useEffect, useState } from 'react'

import { ICountdownTimerProps } from './types'

const CountdownTimer: FC<ICountdownTimerProps> = ({ onResend }) => {
  const [seconds, setSeconds] = useState(60)

  function handleClick() {
    setSeconds(60)
    onResend()
  }

  useEffect(() => {
    if (seconds > 0) {
      const timerId = setTimeout(() => {
        setSeconds(seconds - 1)
      }, 1000)
      return () => clearTimeout(timerId)
    }
  }, [seconds])

  return (
    <div className="flex w-full justify-end">
      {seconds > 0 ? (
        <p className="prose-body-small text-grayscale-600">{`Aguarde ${seconds} segundo(s) para reenviar.`}</p>
      ) : (
        <button
          className="prose-body-small text-grayscale-600 hover:underline cursor-pointer"
          type="button"
          onClick={handleClick}
        >
          Reenviar Código
        </button>
      )}
    </div>
  )
}

export default CountdownTimer
